const questionVersion = '001';

export type Mode = 'ADVICE' | 'WAIVER';

export type ResultDecision = 'CONFIRMED_MATCH' | 'KEPT_ORIGINAL' | 'ACCEPTED_RECOMMENDATION';

type ProductAdviceAnswerItem = {
    QuestionCode: string;
    AnswerCodes: string[];
};

export type ProductAdviceAnswers = Record<string, string>;

export interface ProductAdviceDto {
    Mode: string;
    QuestionSetVersion?: string;
    Answers?: ProductAdviceAnswerItem[];
    ResultDecision?: string;
    InitialInsuranceTypeId?: number;
    RecommendedInsuranceTypeId?: number;
    WaiverConfirmed?: boolean;
}

export interface ProductAdvice {
    mode: Mode;
    answers?: ProductAdviceAnswers;
    resultDecision?: ResultDecision;
    initialInsuranceTypeId?: number;
    recommendedInsuranceTypeId?: number;
    waiverConfirmed?: boolean | null;
}

export const productAdviceToDto = (productAdvice: ProductAdvice): ProductAdviceDto =>
    productAdvice.mode === 'ADVICE'
        ? {
              Mode: productAdvice.mode,
              QuestionSetVersion: questionVersion,
              Answers: Object.entries(productAdvice.answers)
                  .filter(([key]) => key !== 'type')
                  .filter((entry) => entry[1] !== null)
                  .map(([QuestionCode, AnswerCodes]) => ({
                      QuestionCode,
                      AnswerCodes: [AnswerCodes],
                  })),
              ResultDecision: productAdvice.resultDecision,
              InitialInsuranceTypeId: productAdvice.initialInsuranceTypeId,
              RecommendedInsuranceTypeId: productAdvice.recommendedInsuranceTypeId,
          }
        : { Mode: productAdvice.mode, WaiverConfirmed: productAdvice.waiverConfirmed };
